module.exports = __webpack_public_path__ + "img/21.ffeb0a45.png";